/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import AlertHelper from '../app/components/Alert';
import { getUserAccessLevelReal } from "../app/helpers/role";
import NotRegisteredPage from "../app/pages/NotRegisteredPage/index";
import { authProvider } from '../app/provider/authProvider';
import api from '../app/services/api';
import { getVersion } from "../app/version";
import { getUserReal, SetUserData } from "../index";
import env from "../env";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import ModalTermosdeUso from '../app/components/Modal/ModalTermosdeUso';
import { updateUserAccessTerms } from '../app/pages/Users/_redux/crud'

//console.log(window.location)
//window.location.assign('https://nbra-pr-lpp-usea-001-app.azurewebsites.net' + window.location.pathname);

export function Routes() {
    const [loadingUser, setLoadigUser] = useState(true)
    const [userNotFound, setUserNotFound] = useState(false)
    const [termoAcessoModal, setTermoAcessoModal] = useState(false)

    const [snackBar, setSnackBar] = useState({
        isOpen: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
        type: 'error'
    });

    useEffect(() => {

        async function getVersionAsync() {
            const version = await getVersion();
            let versionToStorage = version.versionNumber + '-' + version.dateFile;
            console.log('Carregando version: ' + versionToStorage);
            if (env.ENVIRONMENT == 'Staging' && localStorage.getItem('versioninfo') != versionToStorage) {
                localStorage.removeItem('User');
                localStorage.removeItem('UserReal');
                localStorage.removeItem('Factory');
                localStorage.removeItem('SystemRole');
                localStorage.removeItem('SystemRoleReal');
                localStorage.removeItem('CompanyRole');
                localStorage.removeItem('StructureTree');
                localStorage.removeItem('mediatoken');
            }

            localStorage.setItem('versioninfo', versionToStorage);
        }

        const SetUserDataLocal = async () => {
            const currentUser = getUserReal();
            const userAD = authProvider.getAccount();
            if (currentUser == null || currentUser.email !== userAD.userName || getUserAccessLevelReal() < 10) {
                console.log("Updating user")
				var queryComplementForInactiveUsers = '';
                if (env.ENVIRONMENT == "Production")
                    queryComplementForInactiveUsers += 'and status eq true';
                api.get('/user/GetUser').then((response) => {
                    console.log(response.data);
                    const userDataValue = response.data[0];
                    if (!userDataValue) {
                        console.log('Usuario nao registrado');
                        //history.push("/not-registered");
                        setUserNotFound(true);
                        setLoadigUser(false);
                    }
                    else {
                        SetUserData(userDataValue);
                        setLoadigUser(false);
                        if (userDataValue.firstAccess == null) {                            
                            setTermoAcessoModal(true);                            
                            console.log("Aceita termos de acesso?");
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    //history.push("/not-registered");
                    setUserNotFound(true);
                    setLoadigUser(false);
                })
            }
            else {
                console.log("User " + userAD.name);
                setLoadigUser(false);
            }            
        }

        getVersionAsync();
        SetUserDataLocal();
       
    }, []); // << super important array

    async function AcceptUserTerms() {
        //await api;
        console.log("Termos de acesso aceito.");
        updateUserAccessTerms().then(() => {
            window.location.reload();
        }).catch(() => {
            showMessage('Erro ao aceitar termos de acesso.', 'error');
        })        
    }

    /**
     * Exibe a mensagem de alerta
     * @param {string} msg 
     * @param {string} type 
     */
    const showMessage = (msg, type = 'error') => {
        setSnackBar({ ...snackBar, isOpen: true, message: msg, type });
    }

    /**
     * Fecha a mensagem de alerta
     */
    const handleCloseSnackbar = () => {
        setSnackBar({ ...snackBar, isOpen: false, message: '' });
    }


    return (
      <>
            { !loadingUser &&
                <>
                    {
                    userNotFound?
                        <NotRegisteredPage/> :
                        <Layout>
                            <Snackbar
                                open={snackBar.isOpen}
                                anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
                                key={snackBar.vertical + snackBar.horizontal}
                                autoHideDuration={6000}
                                onClose={handleCloseSnackbar}
                            >
                                <AlertHelper onClose={handleCloseSnackbar} severity={snackBar.type}>
                                    {snackBar.message}
                                </AlertHelper>
                            </Snackbar>
                            <ModalTermosdeUso show={termoAcessoModal} onHide={AcceptUserTerms}/>
                            <BasePage />
                        </Layout>                
                }   
                </>
            }
        </>
  );
}
